import MediaPlayerBody from './MediaPlayerBody';

export default MediaPlayerBody;
